/// <reference path="../../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.Aveda {
    "use strict";

    /**
    * Main Section of tax and currency
    */
    export class MainSection extends Meevo.Components.CommonClasses.CommonSectionBase {

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService,
            protected appSettings: Meevo.Components.Common.IAppSettings,
            private modalService: Meevo.Components.Modal.IModalService,
            sectionSecurityKey: string,
            protected $rootScope: angular.IRootScopeService
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, sectionSecurityKey)

            this.$rootScope.$on(Meevo.Components.Common.Messages.EXTERNAL_ORDERING_ACCESS_TOKEN_OBTAINED, (event, data) => {
                if (data.inventoryApp === Meevo.Model.ExternalInventoryAppEnum.Aveda) {
                    // update the status that it is successful in obtaining the token
                    this.model.hasValidToken = true;
                }
            });
        }

        public activate(): void {
            super.activate();
        }

        callLogin(event: Event) {

            if (this.mode !== Meevo.Model.MaintenanceFormState.Readonly) {
                this.modalService.message("MESSAGE_AVEDA_AUTHORIZE_EDIT_ERROR", Meevo.Components.Modal.ModalTranslationModes.Translate);
                return;
            }

            (event.currentTarget as HTMLElement).blur();

            if (this.$rootScope.popupAvedaLoginWindow && !this.$rootScope.popupAvedaLoginWindow.closed) {
                this.$rootScope.popupAvedaLoginWindow.focus();
                return;
            }

            //this.$rootScope.popupAvedaLoginWindow = window.open(`api/ExternalOrder/Authorize`, "_blank", "width=500,height=500", false);
            const params = { InventoryApp: 11045761/*aveda*/ };
            this.dataService.customMethodData(`api/ExternalOrder/Authorize/State`, 'GET',null, params)
                .then((response) => {
                    this.$rootScope.popupAvedaLoginWindow = window.open(this.model.authorizeUrl + response.data.state.toString(), "_blank", "width=500,height=500", false);
                });
        }

        callLogout() {
            if (this.mode !== Meevo.Model.MaintenanceFormState.Readonly) {
                this.modalService.message("MESSAGE_AVEDA_SAVE_BEFORE_DEAUTHORIZE", Meevo.Components.Modal.ModalTranslationModes.Translate);
                return;
            }

            if (!this.model.hasValidToken) {
                return;
            }
            const params = { inventoryApp: 11045761/*aveda*/ };
            this.dataService.customMethodData(`api/ExternalOrder/Deauthorize`, 'GET', null, params )
                .then((response) => {
                    this.model.hasValidToken = false;
                });
        }
    }
}